import { useEffect, useState } from "react";
import { Doughnut, Pie } from "react-chartjs-2";
import PieChart from "../charts/PieChart";

export default function PemasaranOnline({ data }) {
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: []
  })

  useEffect(() => {
    const mapData = {}
    const rawData = {
      labels: [],
      datasets: [
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 0.8)',
            'rgba(4,135,55, 0.6)',
            'rgba(4,135,55, 0.3)',
            'rgba(4,135,55, 0.2)',
            'rgba(4,135,55, 0.1)',
          ],
          borderColor: [
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    data.map(item => {
      if(item["pemasaran_online"] === 1){
        if (mapData["Ya"] !== undefined) {
          mapData["Ya"] += 1
        }else{
          mapData["Ya"] = 1;
        }
      }else if(item["pemasaran_online"] === 2){
        if (mapData["Tidak"] !== undefined) {
          mapData["Tidak"] += 1
        }else{
          mapData["Tidak"] = 1;
        }
      }else if(item["pemasaran_online"] === 3){
        if (mapData["Tidak tahu"] !== undefined) {
          mapData["Tidak tahu"] += 1
        }else{
          mapData["Tidak tahu"] = 1;
        }
      }
      return item
    })
    rawData.labels = Object.keys(mapData)
    rawData.datasets[0].data = []
    rawData.labels.map(item => {
      rawData.datasets[0].data.push(((mapData[item]/data.filter(item => Number.isInteger(item["pemasaran_online"])).length)*100).toFixed(1))
      return item
    })
    setGraphData(rawData)
  }, [data]);

  return <PieChart data={graphData} />
}